export const basicDetail =
[
  {
    name:"title",
     "rule": {
        "required": true
      },
    label:"Model",
    type:"text"
  },
  {
    name:"makeId",
     "rule": {
        "required": true
      },
    label:"Make",
    type:"dropdown"
  },
  {
    name:"status",
     "rule": {
        "required": true
      },
    label:"Status",
    type:"dropdown"
  }
]

export const statusDD =
[
  { id:1, name:"Active"},
  { id:0, name:"Inactive"}
]
export const editMode =
  [
    {
      name:"modTime",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod Time",
      type:"text"
    },
    {
      name:"modBy",
      disabled:true,
       "rule": {
          "required": false
        },
      label:"Mod By",
      type:"text"
    }
  ]